import React, { useEffect } from "react";
import DashboardLayout from "@src/layouts/DashboardLayout";
import { navigate } from "gatsby";
import { useLangContext } from "@src/components/LangProvider";
import Loader from "@src/components/Loader";
import { useAuthGlobalContext } from "@src/components/Auth";

export default () => {
	const { switchLang } = useLangContext();
	const { user, validateActions } = useAuthGlobalContext();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const lang = urlParams.get("lang");
		if (lang) {
			switchLang(lang);
		}
		if (user.policies.length === 0) {
			return;
		} else if (validateActions(["contracts:listOrgContracts"]) || validateActions(["contracts:listContracts"])) {
			navigate("/contract");
		} else if (validateActions(["contracts:putContract"])) {
			navigate("/create-contract");
		} else if (user.organizationRole && ["helpdesk", "security"].includes(user.organizationRole)) {
			navigate("/profile/?page=myaccount");
		} else {
			navigate("/dashboard");
		}
	}, [user.policies]);
	return (
		<DashboardLayout>
			<div className="d-flex flex-column flex-justify-center flex-items-center p-5">
				<Loader />
			</div>
		</DashboardLayout>
	);
};
